import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Browser from './icon-browser.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Browser {...validProps} />;
}
SvgComponent.iconName = 'browser';

export const BrowserIcon = svgIconWrapper(SvgComponent);
